/**
 * Теги каталогов — общая палитра и типы.
 *
 * Словарь тегов у макетов и товаров один и тот же (attribute_values,
 * field='tag'), поэтому и цвета обязаны совпадать: «Хит» не должен быть
 * зелёным на одной странице и синим на другой.
 */

export type TagColor = 'green' | 'blue' | 'purple' | 'yellow' | 'orange' | 'red' | 'gray'

export interface CatalogTag {
  id: number
  value: string
  color: TagColor | string
  /** Счётчик использования, если backend его отдаёт */
  count?: number
}

/** Чипы тегов в строках таблицы и карточках */
export const TAG_CHIP_CLASSES: Record<TagColor, string> = {
  green: 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300',
  purple: 'bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300',
  yellow: 'bg-yellow-100 text-yellow-700 dark:bg-yellow-950 dark:text-yellow-300',
  orange: 'bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-300',
  red: 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300',
  gray: 'bg-gray-100 text-gray-700 dark:bg-zinc-800 dark:text-zinc-300',
}

export const TAG_DOT_CLASSES: Record<TagColor, string> = {
  green: 'bg-green-500',
  blue: 'bg-blue-500',
  purple: 'bg-purple-500',
  yellow: 'bg-yellow-500',
  orange: 'bg-orange-500',
  red: 'bg-red-500',
  gray: 'bg-gray-400',
}

export const TAG_COLORS: TagColor[] = ['green', 'blue', 'purple', 'yellow', 'orange', 'red', 'gray']

export function tagChipClass(color: string | undefined): string {
  return TAG_CHIP_CLASSES[(color as TagColor) || 'blue'] ?? TAG_CHIP_CLASSES.blue
}

export function tagDotClass(color: string | undefined): string {
  return TAG_DOT_CLASSES[(color as TagColor) || 'blue'] ?? TAG_DOT_CLASSES.blue
}

/** Цвет для нового тега — по кругу палитры */
export function nextTagColor(index: number): TagColor {
  return TAG_COLORS[index % TAG_COLORS.length]
}
